export const checkIfJobTilesHaveProfile = () => {
    const jobsWidget = document.querySelectorAll(".jobs-carousel");

    if (!jobsWidget) return;

    jobsWidget.forEach((widget) => {
        const hasProfile = widget.querySelector(
            ".attrax-vacancy-tile__author-image-link"
        );

        if (hasProfile) {
            widget.classList.add("has-profile");
        }
    });
};


export const moveReadMoreButtonLatestStories = () => {
    const readmoreButons = document.querySelectorAll<HTMLAnchorElement>(".post-block-latest .attrax-list-widget__readmore");

    readmoreButons.forEach((button) => {
        const listwidget = button.closest(".attrax-list-widget");
        const tabs = listwidget?.querySelector(".attrax-list-widget__tabs");

        if (tabs) {
            tabs.appendChild(button);
        }
    });
};